import React, { Component } from 'react'
import { Row } from 'react-bootstrap';
import '../css/TopMenu.css'

class TopMenu extends Component {

    render() {
        return (
            <React.Fragment>
                <Row>
                    <h1 className='header'> בחירות איזוריות בישראל </h1>
                </Row>
                <Row>
                    <h2 className='miniHeader'> מודל בן-זקן - בראון</h2>
                </Row>
            </React.Fragment>
        );
    }
}

export default TopMenu;